import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../header/Headers.jsx';
import Footer from '../footer/Footer.jsx';


export default function Mainroutes({setting_data , openSchemes , setopenSchemes, footerpages}) {



  return (
    //made changes by adding the app-container class and main content for footer layout
    <>
    <div className='app-container'>
        <>
        <Header openScheme={openSchemes} setopenScheme={setopenSchemes} setting_datas={setting_data} />
        <div className='main-content body_top'>
            <Outlet/>
        </div>
        </>
        <Footer setting_datas={setting_data} footerpages={footerpages}  />
    </div>
    </>
  )
}
